import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Offcanvas, Form } from "react-bootstrap";
import { MdArrowBack } from "react-icons/md";
import * as apicall from "../../components/Apicall";
import Skeleton from "../../components/Loader/Skeleton";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { Formik } from "formik";
import * as Yup from "yup";
import CurrencyDropdown, { CURRENCIES } from "../Dashboard/CurrencyDropdown";

const ViewProfile = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEditSidebar, setShowEditSidebar] = useState(false);
  const [fallbackColor, setFallbackColor] = useState("");
const [removedImage, setRemovedImage] = useState(false);
  const currencyCode = userData?.personalDetails?.currency;
  const loginType = localStorage.getItem("login_type");
  const currencyObj = CURRENCIES.find((c) => c.code === currencyCode);

  const getRandomColor = () => {
    const colors = [
      "#FFE4E1", // Misty Rose
      "#E6E6FA", // Lavender
      "#F0FFF0", // Honeydew
      "#F0F8FF", // Alice Blue
      "#FFF0F5", // Lavender Blush
      "#F5F5DC", // Beige
      "#E0FFFF", // Light Cyan
      "#FFE4B5", // Moccasin
      "#F0FFFF", // Azure
      "#F8F8FF", // Ghost White
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const getInitials = (name) => {
    if (!name) return "";
    const nameParts = name.split(" ").filter((part) => part.length > 0);
    if (nameParts.length === 0) return "";
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const response = await apicall.get("ezpMyProfile");
        const profile = response.data[0];
        const transformedData = {
          personalDetails: {
            fullName: `${profile.first_name}`.trim(),
            gender: profile.gender === 1 ? "Male" : "Female",
            currency: profile.currency || "",
            totalExperience: profile.practice_start
              ? calculateExperience(profile.practice_start)
              : "",
            id: profile?.id,
            vendor_id: profile?.vendor_id,
            State:profile?.state_name,
            Country:profile?.country_name,
            phone_number:profile?.phone_number,
            image:profile?.image,
            email:profile?.email,
            address:profile?.address,
            profile_image:profile?.profile_image,
            city_name:profile?.city_name
          },
          addressDetails: {
            address: profile.address || "",
            city: profile.city_name || "",
            state: profile.state_name || "",
            country: profile.country_name || "",
          },
          contactDetails: {
            phoneNumber: profile.phone_number || "",
            email: profile.email || "",
          },
          profile_image: profile.profile_image || "",
          image: profile.image || "",
          website_link: profile.website_link || "",
          notes: profile.notes || "",
          tax:profile?.tax
        };

        setUserData(transformedData);
        setFallbackColor(getRandomColor());
        setError(null);
      } catch (err) {
        console.error("Error fetching profile data:", err);
        setError("Failed to load profile data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleEditProfile = () => {
    setShowEditSidebar(true);
  };

  const calculateExperience = (practiceStart) => {
    if (!practiceStart) return "0";
    const startDate = new Date(practiceStart);
    const currentDate = new Date();
    const years = currentDate.getFullYear() - startDate.getFullYear();
    return `${years} Years Experience`;
  };

  const EditProfileSidebar = ({ 
  showEditSidebar, 
  setShowEditSidebar, 
  userData 
}) => {
    const [formData, setFormData] = useState({
      first_name: userData?.personalDetails.fullName.split(" ")[0] || "",
      gender: userData?.personalDetails.gender === "Male" ? 1 : 2,
      currencyCode: userData?.personalDetails.currency || "USD",
      address: userData?.addressDetails.address || "",
      city_id: "",
      state_id: "",
      country_id: "",
      phone_number: userData?.contactDetails.phoneNumber || "",
      email: userData?.contactDetails.email || "",
profile_image: userData?.profile_image || "",
  image: userData?.image || "",
  notes: userData?.notes || "",
  website_link: userData?.website_link || "",
  tax:userData?.tax  || "",
    });
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const profileSchema = Yup.object().shape({
      first_name: Yup.string().required("Full name is required"),
      // gender: Yup.number().oneOf([1, 2], "Gender is required"),
      country_id: Yup.string().required("Country is required"),
      state_id: Yup.string().required("State is required"),
      // city_id: Yup.string().when([], function (_, context) {
      //   const cities = context && context.cities;
      //   if (cities && cities.length > 0) {
      //     return Yup.string().required('City is required');
      //   }
      //   return Yup.string();
      // }),
      email: Yup.string().email("Invalid email").required("Email is required"),
    });
const [newImage, setNewImage] = useState(null);
const [profileImage, setProfileImage] = useState(null);
  const [removeLogo, setRemoveLogo] = useState(false);
const [removeCollab, setRemoveCollab] = useState(false);
const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const maxSize = 200 * 1024;
  if (file.size > maxSize) {
    toast.error("Image size should be less than 200KB");
    return;
  }

  setRemoveCollab(false);

  const reader = new FileReader();
  reader.onloadend = () => {
    setNewImage(reader.result);
  };
  reader.readAsDataURL(file);
};

const handleProfileImageUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const maxSize = 200 * 1024;
  if (file.size > maxSize) {
    toast.error("Image size should be less than 200KB");
    return;
  }

  setRemoveLogo(false);

  const reader = new FileReader();
  reader.onloadend = () => {
    setProfileImage(reader.result);
  };
  reader.readAsDataURL(file);
};
    const fetchCountries = async () => {
      try {
        const response = await apicall.get("country");

        if (response?.data) {
          // Handle both array and object responses
          const countriesData = Array.isArray(response.data)
            ? response.data
            : [response.data];
          setCountries(countriesData);
          return countriesData;
        }
        return [];
      } catch (error) {
        console.error("Error fetching countries:", error);
        return [];
      }
    };

    const fetchStates = async (countryId) => {
      if (!countryId) {
        return [];
      }
      try {
        const response = await apicall.get(`state/${countryId}`);
        if (response?.data) {
          const statesData = Array.isArray(response.data)
            ? response.data
            : [response.data];
          setStates(statesData);
          return statesData;
        }
        setStates([]);
        return [];
      } catch (error) {
        console.error("Error fetching states:", error);
        setStates([]);
        return [];
      }
    };

    const fetchCities = async (stateId) => {
      if (!stateId) {
        return [];
      }
      try {
        const response = await apicall.get(`city/${stateId}`);
        if (response?.data) {
          const citiesData = Array.isArray(response.data)
            ? response.data
            : [response.data];
          setCities(citiesData);
          return citiesData;
        }
        setCities([]);
        return [];
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]);
        return [];
      }
    };

    // Initial data load
    useEffect(() => {
      const initializeData = async () => {
        try {
          setIsLoading(true);
          // Fetch countries first
          const countriesData = await fetchCountries();
          if (countriesData.length > 0) {
            // Find country by name first
            const currentCountry = countriesData.find((c) => {
              const countryName = c.country_name || c.name;
              const searchName = userData?.addressDetails?.country;
              return countryName?.toLowerCase() === searchName?.toLowerCase();
            });

            if (currentCountry) {
              const countryId = currentCountry.id || currentCountry.country_id;
              setFormData((prev) => ({ ...prev, country_id: countryId }));
              // Fetch states for the selected country
              const statesData = await fetchStates(countryId);
              if (statesData.length > 0) {
                // Log the current state name we're looking for
                // Find state by name
                const currentState = statesData.find((s) => {
                  const stateName = s.state_name || s.name;
                  const searchName = userData?.addressDetails?.state;
                  return stateName?.toLowerCase() === searchName?.toLowerCase();
                });
                if (currentState) {
                  const stateId = currentState.id || currentState.state_id;
                  setFormData((prev) => ({ ...prev, state_id: stateId }));
                  // Fetch cities for the selected state
                  const citiesData = await fetchCities(stateId);
                  if (citiesData.length > 0) {
                    // Find city by name
                    const currentCity = citiesData.find((c) => {
                      const cityName = c.city_name || c.name;
                      const searchName = userData?.addressDetails?.city;
                      return (
                        cityName?.toLowerCase() === searchName?.toLowerCase()
                      );
                    });
                    if (currentCity) {
                      const cityId = currentCity.id || currentCity.city_id;
                      setFormData((prev) => ({ ...prev, city_id: cityId }));
                    }
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error("Error initializing data:", error);
        } finally {
          setIsLoading(false);
        }
      };
      if (userData) {
        initializeData();
      }
    }, [userData]);

    const handleInputChange = async (e) => {
      const { name, value } = e.target;

      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      // Handle cascading updates
      if (name === "country_id") {
        if (value) {
          await fetchStates(value);
          // Reset state and city when country changes
          setFormData((prev) => ({
            ...prev,
            state_id: "",
            city_id: "",
          }));
          setCities([]);
        } else {
          setStates([]);
          setCities([]);
          setFormData((prev) => ({ ...prev, state_id: "", city_id: "" }));
        }
      } else if (name === "state_id") {
        if (value) {
          await fetchCities(value);
          // Reset city when state changes
          setFormData((prev) => ({
            ...prev,
            city_id: "",
          }));
        } else {
          setCities([]);
          setFormData((prev) => ({ ...prev, city_id: "" }));
        }
      }
    };

    const handleSubmit = async (values) => {
      // Prepare the payload
      const payload = {
        first_name: values.first_name,
        gender: values.gender,
        currency: values.currencyCode,
        address: values.address,
        country_id: values.country_id,
        state_id: values.state_id,
        city_id: cities && cities.length > 0 ? values.city_id : null,
        phone_number: values.phone_number,
        // profile_image: profileImage ? profileImage : userData.profile_image,
        // image: newImage ? newImage : userData.image,
        website_link:values?.website_link,
        notes:values?.notes,
        tax:values?.tax
      };

// LOGO
if (profileImage) {
  payload.profile_image = profileImage; // ✅ priority
} else if (removeLogo) {
  payload.profile_image = "";
}

// COLLAB IMAGE
if (newImage) {
  payload.image = newImage; // ✅ priority
} else if (removeCollab) {
  payload.image = "";
}

      if (values.email !== userData.contactDetails.email) {
        payload.email = values.email;
      }
     

      try {
        const response = await apicall.post(payload, "ezpUpdateUser");
        if (response.status === 200) {
          toast.success("Profile updated successfully", { autoClose: 1500 });
          setShowEditSidebar(false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        console.error("Error details:", error.response?.data);
        toast.error("Failed to update profile. Please try again.");
      }
    };

    const SidebarSkeleton = () => {
      return (
        <div className="p-4">
          <div className="mb-4">
            <Skeleton width="120px" height="24px" marginBottom="16px" />
            {[...Array(5)].map((_, index) => (
              <div key={index} className="mb-3">
                <Skeleton width="100px" height="20px" marginBottom="8px" />
                <Skeleton width="100%" height="38px" />
              </div>
            ))}
          </div>

          <div className="mb-4">
            <Skeleton width="120px" height="24px" marginBottom="16px" />
            {[...Array(4)].map((_, index) => (
              <div key={index} className="mb-3">
                <Skeleton width="100px" height="20px" marginBottom="8px" />
                <Skeleton width="100%" height="38px" />
              </div>
            ))}
          </div>

          <div className="mb-4">
            <Skeleton width="120px" height="24px" marginBottom="16px" />
            {[...Array(2)].map((_, index) => (
              <div key={index} className="mb-3">
                <Skeleton width="100px" height="20px" marginBottom="8px" />
                <Skeleton width="100%" height="38px" />
              </div>
            ))}
          </div>
        </div>
      );
    };

    return (
      <Offcanvas
        show={showEditSidebar}
        onHide={() => setShowEditSidebar(false)}
        placement="end"
        style={{ width: "100%", maxWidth: "500px" }}
        // className="d-flex flex-column"
      >
        <Offcanvas.Header closeButton className="custom-border-bottom p-4">
          <Offcanvas.Title className="page-heading">
            Edit Profile
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0 d-flex flex-column">
          {isLoading ? (
            <SidebarSkeleton />
          ) : (
            <div className="flex-grow-1 overflow-auto p-4">
              <Formik
                initialValues={formData}
                validationSchema={profileSchema}
                onSubmit={handleSubmit}
                enableReinitialize
                validationContext={{ cities }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}
                  className="d-flex flex-column h-100"
            style={{ height: "100%" }}
                  >
                    <div
                     style={{
                flex: 1,
                // overflowY: "auto",
                // padding: "16px",
                paddingBottom: "65px", 
              }}
                    >
                       <div className="mb-4"
                    >
                      <h6 className="profile-section-heading">
                        Personal Details
                      </h6>
                      <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="first_name"
                          value={values.first_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.first_name && errors.first_name}
                          className="form-input"
                        />
                        {touched.first_name && errors.first_name && (
                          <div className="invalid-feedback d-block">
                            {errors.first_name}
                          </div>
                        )}
                      </Form.Group>

                      {/* <Form.Group className="mb-3">
                        <Form.Label>Gender</Form.Label>
                        <Form.Select
                          name="gender"
                          value={values.gender}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.gender && errors.gender}
                          className="form-input"
                        >
                          <option value={1}>Male</option>
                          <option value={2}>Female</option>
                        </Form.Select>
                        {touched.gender && errors.gender && (
                          <div className="invalid-feedback d-block">
                            {errors.gender}
                          </div>
                        )}
                      </Form.Group> */}
                    </div>

                    <div className="mb-4">
                      <Form.Group className="mb-3">
                        <Form.Label>Country</Form.Label>
                        <Form.Select
                          name="country_id"
                          value={values.country_id}
                          onChange={async (e) => {
                            const countryId = e.target.value;
                            setFieldValue("country_id", countryId);
                            if (countryId) {
                              await fetchStates(countryId);
                              setFieldValue("state_id", "");
                              setFieldValue("city_id", "");
                              setCities([]);
                            } else {
                              setStates([]);
                              setCities([]);
                              setFieldValue("state_id", "");
                              setFieldValue("city_id", "");
                            }
                          }}
                          isInvalid={touched.country_id && errors.country_id}
                          className="form-input label-bgcolor"
                          // disabled
                        >
                          <option value="">Select Country</option>
                          {countries.map((country) => (
                            <option key={country.id} value={country.id}>
                              {country.name || country.country_name}
                            </option>
                          ))}
                        </Form.Select>
                        {touched.country_id && errors.country_id && (
                          <div className="invalid-feedback d-block">
                            {errors.country_id}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>State</Form.Label>
                        <Form.Select
                          name="state_id"
                          value={values.state_id}
                          onChange={async (e) => {
                            const stateId = e.target.value;
                            setFieldValue("state_id", stateId);
                            if (stateId) {
                              const fetchedCities = await fetchCities(stateId);
                              if (
                                !fetchedCities ||
                                fetchedCities.length === 0
                              ) {
                                setFieldValue("city_id", null);
                              } else {
                                setFieldValue("city_id", "");
                              }
                            } else {
                              setCities([]);
                              setFieldValue("city_id", null);
                            }
                          }}
                          isInvalid={touched.state_id && errors.state_id}
                          className="form-input label-bgcolor"
                          // disabled
                        >
                          <option value="">Select State</option>
                          {states.map((state) => (
                            <option key={state.id} value={state.id}>
                              {state.name}
                            </option>
                          ))}
                        </Form.Select>
                        {touched.state_id && errors.state_id && (
                          <div className="invalid-feedback d-block">
                            {errors.state_id}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>City</Form.Label>
                        <Form.Select
                          name="city_id"
                          value={values.city_id}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.city_id && errors.city_id}
                          className="form-input label-bgcolor"
                          // disabled
                        >
                          <option value="">Select City</option>
                          {cities.map((city) => (
                            <option key={city.id} value={city.id}>
                              {city.name}
                            </option>
                          ))}
                        </Form.Select>
                        {touched.city_id && errors.city_id && (
                          <div className="invalid-feedback d-block">
                            {errors.city_id}
                          </div>
                        )}
                      </Form.Group>
                      {/* <Form.Group className="mb-3"> */}

                      <Form.Label>Currency</Form.Label>
                      <CurrencyDropdown
                        currencyCode={values.currencyCode}
                        currencyChange={(data) =>
                          setFieldValue("currencyCode", data)
                        }
                      />
                    </div>

                    <div className="mb-4">
                      <h6 className="profile-section-heading">
                        Contact Details
                      </h6>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone Number</Form.Label>
                        <PhoneInput
                          country={"ae"}
                          onlyCountries={["ae", "in"]}
                          value={values.phone_number}
                          onChange={(value) => {
                            const cleanedValue = value.replace(/\D/g, "");
                            setFieldValue("phone_number", cleanedValue);
                          }}
                          inputStyle={{
                            width: "100%",
                            height: "40px",
                            backgroundColor: "#F8F9FA",
                            borderColor: "#E9ECEF",
                          }}
                          inputProps={{
                            name: "phone_number",
                            required: true,
                            disabled: loginType === "phone",
                            // disabled: true
                          }}
                          // disabled
                        />
                      </Form.Group>
                         <Form.Group className="mb-3">
                        <Form.Label>Tax</Form.Label>
                        <Form.Control
                          type="text"
                          name="tax"
                          value={values.tax}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.tax && errors.tax}
                          className="form-input"
                        />
                        {/* {touched.tax && errors.tax && (
                          <div className="invalid-feedback d-block">
                            {errors.tax}
                          </div>
                        )} */}
                      </Form.Group>
                    <Form.Group className="mb-3">
  <Form.Label>Upload Logo</Form.Label>

  <Form.Control
    type="file"
    accept="image/*"
    onChange={handleProfileImageUpload}
  />

  {/* SHOW NEW IMAGE FIRST */}
  {profileImage ? (
    <div className="mt-2 position-relative" style={{ width: "80px" }}>
      <img src={profileImage} className="img-preview" />
      <span
        className="remove-btn"
        onClick={() => setProfileImage(null)}
      >
        ×
      </span>
    </div>
  ) : (
    userData?.profile_image &&
    !removeLogo && (
      <div className="mt-2 position-relative" style={{ width: "80px" }}>
        <img src={userData.profile_image} className="img-preview" />
        <span
          className="remove-btn"
          onClick={() => {
            setRemoveLogo(true);
            setProfileImage(null);
          }}
        >
          ×
        </span>
      </div>
    )
  )}
</Form.Group>
   <Form.Group className="mb-3">
                        <Form.Label>Website Link</Form.Label>
                        <Form.Control
                          type="text"
                          name="website_link"
                          value={values.website_link}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.website_link && errors.website_link}
                          className="form-input"
                        />
                        {/* {touched.website_link && errors.website_link && (
                          <div className="invalid-feedback d-block">
                            {errors.website_link}
                          </div>
                        )} */}
                      </Form.Group>
                         <Form.Group className="mb-3">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control
                          type="text"
                          name="notes"
                          value={values.notes}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.notes && errors.notes}
                          className="form-input"
                        />
                        {touched.notes && errors.notes && (
                          <div className="invalid-feedback d-block">
                            {errors.notes}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.email && errors.email}
                          className="form-input"
                        />
                        {touched.email && errors.email && (
                          <div className="invalid-feedback d-block">
                            {errors.email}
                          </div>
                        )}
                      </Form.Group>
              <Form.Group className="mb-3">
  <Form.Label>Upload Collaboration</Form.Label>

  <Form.Control
    type="file"
    accept="image/*"
    onChange={handleImageUpload}
  />

  {/* SHOW NEW IMAGE FIRST */}
  {newImage ? (
    <div className="mt-2 position-relative" style={{ width: "80px" }}>
      <img src={newImage} className="img-preview" />
      <span
        className="remove-btn"
        onClick={() => setNewImage(null)}
      >
        ×
      </span>
    </div>
  ) : (
    userData?.image &&
    !removeCollab && (
      <div className="mt-2 position-relative" style={{ width: "80px" }}>
        <img src={userData.image} className="img-preview" />
        <span
          className="remove-btn"
          onClick={() => {
            setRemoveCollab(true);
            setNewImage(null);
          }}
        >
          ×
        </span>
      </div>
    )
  )}
</Form.Group>
                    </div>

<div className="bg-white custom-border-top p-3 d-flex gap-3">                      <Button
                        variant="light"
                        onClick={() => setShowEditSidebar(false)}
                        className="custom-radius btn-outline-borders"
                        type="button"
                        style={{ flex: 1 }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-custom-danger custom-radius"
                        type="submit"
                        style={{ flex: 1 }}
                      >
                        Save Changes
                      </Button>
                    </div>
                    </div>
                   
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    );
  };
  const handleNavigate = () => {
    navigate(`/book-service/vendor/${userData.personalDetails.vendor_id}`, {
      state: { personalDetails: userData.personalDetails },
    });
  };
  const ProfileSkeleton = () => {
    return (
      <div className="px-4 py-3">
        <div className="d-flex align-items-center mb-4">
          <Skeleton width="80px" height="24px" />
        </div>

        <div className="bg-white border-box p-4 rounded-4">
          <div className="d-flex gap-5">
            {/* Left Column - Profile Image Skeleton */}
            <div
              className="d-flex flex-column align-items-center"
              style={{ width: "258px" }}
            >
              <Skeleton width="258px" height="248px" marginBottom="16px" />
              <Skeleton width="121px" height="32px" />
            </div>

            {/* Right Column - Details Skeleton */}
            <div className="flex-grow-1">
              <div className="row g-4">
                {/* Personal Details Skeleton */}
                <div className="col-md-4">
                  <Skeleton width="120px" height="24px" marginBottom="16px" />
                  <div className="d-flex flex-column gap-3">
                    {[...Array(4)].map((_, index) => (
                      <div key={index}>
                        <Skeleton
                          width="80px"
                          height="16px"
                          marginBottom="8px"
                        />
                        <Skeleton width="140px" height="20px" />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Address Details Skeleton */}
                <div className="col-md-4">
                  <Skeleton width="120px" height="24px" marginBottom="16px" />
                  <div className="d-flex flex-column gap-3">
                    {[...Array(4)].map((_, index) => (
                      <div key={index}>
                        <Skeleton
                          width="80px"
                          height="16px"
                          marginBottom="8px"
                        />
                        <Skeleton width="140px" height="20px" />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Details Skeleton */}
                <div className="col-md-4">
                  <Skeleton width="120px" height="24px" marginBottom="16px" />
                  <div className="d-flex flex-column gap-3">
                    {[...Array(2)].map((_, index) => (
                      <div key={index}>
                        <Skeleton
                          width="80px"
                          height="16px"
                          marginBottom="8px"
                        />
                        <Skeleton width="140px" height="20px" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return <ProfileSkeleton />;
  }

  if (error) {
    return <div className="p-4 text-danger">{error}</div>;
  }

  if (!userData) {
    return <div className="p-4">No profile data available</div>;
  }

  return (
    <div className="px-4 py-3">
      <div className="d-flex align-items-center mb-4">
        <Button
          variant="link"
          className="back-button text-dark text-decoration-none p-0"
          onClick={handleBack}
        >
          <MdArrowBack size={20} /> BACK
        </Button>
      </div>

      <div className="bg-white border-box p-4 rounded-4">
        <div className="d-flex flex-column flex-lg-row gap-4">
          {/* Left Column - Profile Image */}
          <div
  className="d-flex flex-column align-items-center col-12 col-md-auto"
  style={{
    maxWidth: "258px",
    width: "100%",
    margin: "0 auto",
  }}
>
            <div
              className="position-relative w-100"
              style={{
                paddingBottom: "100%", // Creates a 1:1 aspect ratio
                height: "0",
                minHeight: "200px",
                maxHeight: "258px",
              }}
            >
              {userData.profile_image ? (
                <img
                   src={userData.profile_image.startsWith("https")
        ? userData.profile_image
        : userData.profile_image}
                  alt={userData.personalDetails.fullName}
                  className="border-box profile-image-shadow w-100 h-100"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    borderRadius: "20px",
                    objectFit: "cover",
                    minHeight: "200px",
                    maxHeight: "258px",
                  }}
                  // onError={(e) => {
                  //   e.target.style.display = "none";
                  //   e.target.nextElementSibling.style.display = "flex";
                  // }}
                />
              ) : null}
              {!userData.profile_image && (
  <div
    className="border-box profile-image-shadow d-flex align-items-center justify-content-center"
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "20px",
      backgroundColor: fallbackColor,
      fontSize: "40px",
      fontWeight: "600",
      color: "#666",
    }}
  >
    {getInitials(userData.personalDetails.fullName)}
  </div>
)}
              {/* <div
                className="border-box profile-image-shadow d-flex align-items-center justify-content-center w-100 h-100"
                 style={{
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        backgroundColor: fallbackColor,
        fontSize: "14px",
        fontWeight: "500",
        color: "#666",
      }}
                // style={{
                //   position: "absolute",
                //   top: "0",
                //   left: "0",
                //   borderRadius: "20px",
                //   backgroundColor: fallbackColor,
                //   display: userData.profile_image ? "none" : "flex",
                //   fontSize: "calc(32px + 2vw)",
                //   fontWeight: "500",
                //   color: "#666666",
                //   minHeight: "200px",
                //   maxHeight: "258px",
                // }}
              >
                {getInitials(userData.personalDetails.fullName)}
              </div> */}
            </div>
<div className="d-flex justify-content-center gap-3 mt-3 mb-3 w-100">
              <Button
                variant="danger"
                onClick={handleEditProfile}
                 className="btn-custom-danger custom-radius d-flex align-items-center justify-content-center"
    style={{
      width: "121px",
      height: "32px",
      padding: "10px 16px",
      fontSize: "14px",
      fontWeight: "500",
    }}
              >
                Edit Profile
              </Button>
            </div>
          </div>

          {/* Right Column - Details */}
          <div className="flex-grow-1">
            <div className="row g-4">
              {/* Personal Details */}
              <div className="col-12 col-md-6 col-lg-4">
                <h6 className="profile-section-heading">Personal Details</h6>
                <div className="d-flex flex-column gap-3">
                  <div>
                    <div className="label mb-1">Full Name</div>
                    <div
                      className="content fw-bold text-dark text-break"
                      style={{
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        maxWidth: "100%",
                      }}
                    >
                      {userData.personalDetails.fullName}
                    </div>
                  </div>
                  <div>
                    {/* <div className="label mb-1">Gender</div>
                    <div className="content fw-bold text-dark text-break">
                      {userData.personalDetails.gender}
                    </div> */}
                    {/* <div className="label mb-1">Booking Link</div> */}
                    <div className="content fw-bold text-dark text-break">
                      {/* {userData?.personalDetails?.vendor_id && (
                        <span
                          onClick={() => {
                            const url = `/book-service/vendor/${userData.personalDetails.vendor_id}`;
                            localStorage.setItem(
                              "userDetails",
                              JSON.stringify(userData.personalDetails)
                            );
                            window.open(url, "_blank");
                          }}
                          style={{
                            color: "#dc3545",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {`/book-service/vendor/${userData.personalDetails.vendor_id}`}
                        </span>
                      )} */}

                      {userData?.personalDetails?.vendor_id && (
                        <button
                          className="btn btn-danger"
                          onClick={() => {
                            const url = `/book-service/vendor/${userData.personalDetails.vendor_id}`;
                            localStorage.setItem(
                              "userDetails",
                              JSON.stringify(userData.personalDetails)
                            );
                            window.open(url, "_blank");
                          }}
                        >
                          {/* Link for Customers */}
                          Booking Link
                        </button>
                      )}
                    </div>
                  </div>

                  <div>
                    <div className="label mb-1">Currency</div>
                    <div className="content fw-bold text-dark text-break">
                      {currencyObj?.symbol} {currencyObj?.code}
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>

              {/* Address Details */}
              <div className="col-12 col-md-6 col-lg-4">
                <h6 className="profile-section-heading">Address Details</h6>
                <div className="d-flex flex-column gap-3">
                  {/* <div>
                    <div className="label mb-1">Address Line</div>
                    <div className="content fw-bold text-dark text-break" style={{ 
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      maxWidth: '100%'
                    }}>{userData.addressDetails.address}</div>
                  </div> */}
                  <div>
                    <div className="label mb-1">City</div>
                    <div className="content fw-bold text-dark text-break">
                      {userData.addressDetails.city}
                    </div>
                  </div>
                  <div>
                    <div className="label mb-1">State</div>
                    <div className="content fw-bold text-dark text-break">
                      {userData.addressDetails.state}
                    </div>
                  </div>
                  <div>
                    <div className="label mb-1">Country</div>
                    <div className="content fw-bold text-dark text-break">
                      {userData.addressDetails.country}
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Details */}
              <div className="col-12 col-md-6 col-lg-4">
                <h6 className="profile-section-heading">Contact Details</h6>
                <div className="d-flex flex-column gap-3">
                  <div>
                    <div className="label mb-1">Phone Number</div>
                    <div className="content fw-bold text-dark text-break">
                      {userData.contactDetails.phoneNumber}
                    </div>
                  </div>
                  <div>
                    <div className="label mb-1">Email</div>
                    <div
                      className="content fw-bold text-dark text-break"
                      style={{
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        maxWidth: "100%",
                      }}
                    >
                      {userData.contactDetails.email}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EditProfileSidebar 
      showEditSidebar={showEditSidebar}
  setShowEditSidebar={setShowEditSidebar}
  userData={userData}
      />
    </div>
  );
};

export default ViewProfile;
